import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

import AuthFormInterface from './interfaces/AuthFormInterface.interface';

export interface AuthFormBySlugData {
	slug: string;
}

export interface AuthFormBySlugResponse {
	form: AuthFormInterface;
	status: number;
}

const getAuthFormBySlug = configRequest<AuthFormBySlugResponse, AuthFormBySlugData>({
	requestPrefix: 'authForms/getAuthFormBySlug',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.AUTH_FORMS.GET_AUTH_FORM_BY_SLUG({ slug: data?.slug }),
		method: HTTP_METHODS_ENUM.GET,
	}),
});

export default getAuthFormBySlug;
